import template from './detalles.html';
import modalTemplate from './cancelar.html';
import procesarTemplate from './procesar-comision.html';
import { FormActions } from 'core/services/form';
import detallesI18N from 'i18n/ordenes/es.json';
import { fechaHoraRenderer, horaRenderer } from 'core/util';
import { rest } from 'core/api';
import { formatErrorMessage } from 'core/util';

export let DetallesComponent = {
  templateUrl: template,
  selector: 'ordenesDetallesList',
  bindings: {
    translations: '='
  },
  controller: DetallesCtrl,
  controllerAs: 'vm'
};

const commonsI18N = [
  'Elemento borrado correctamente'
];
export const translationKeys = Object.keys(detallesI18N).concat(commonsI18N);

DetallesCtrl.$inject = [
  'BasicFactory', '$ngRedux', '$state', 'ngNotify', 'Filter', 'AuthorizationService', 'CustomModal', '$filter'
];

function DetallesCtrl(BasicFactory, $ngRedux, $state, ngNotify, Filter,
  AuthorizationService, CustomModal, $filter) {

  Object.assign(this, { $state, $ngRedux, ngNotify });
  var defaultColumnOrder = ['codigo', 'orden.cliente.razonSocial', 'servicio.nombre', 'especialista.nombre', 'especialista.apellido', 'fechaCita', 'fechaInicio', 'fechaFin', 'tipo.value', 'estadoDetalle.value'];

  BasicFactory.setup('ordenes');

  const estadoQuery = Filter.path('tipo.codigo').eq('estado_detalle_orden_trabajo');
  const estadoUrl = encodeURI('valores?filter=' + JSON.stringify(estadoQuery));

  this.tipos = [{ value: 'Giftcard' }, { value: 'Paquete' }];
  this.localModel = {};
  this.options = {
    resource: 'ordenes-de-trabajo-detalles',
    hideHeader: true,
    hasOptions: true,
    title: this.translations['Listado de detalles'],
    factory: BasicFactory,
    defaultColumnOrder: defaultColumnOrder,
    columns: [
      { data: 'id', title: 'Id' },
      { data: 'codigo', title: this.translations['Código'] },
      { data: 'orden.cliente.razonSocial', title: this.translations['Cliente'], name: 'cabecera.cliente.razonSocial' },
      { data: 'servicio.nombre', title: this.translations['Servicio'] },
      { data: 'especialista.nombre', title: this.translations['Nombre Especialista'] },
      { data: 'especialista.apellido', title: this.translations['Apellido Especialista'] },
      { data: 'fechaCita', title: this.translations['Fecha Cita'], renderWith: fechaHoraRenderer, type: 'date-range' },
      { data: 'fechaInicio', title: this.translations['Hora Inicio'], renderWith: horaRenderer },
      { data: 'fechaFin', title: this.translations['Hora Fin'], renderWith: horaRenderer },
      { data: 'tipo.value', title: this.translations['Tipo'], name: 'tipo.value' },
      {
        data: 'estadoDetalle.value',
        title: this.translations['Estado'],
        type: 'combo',
        filterUrl: estadoUrl,
        idField: 'value',
        textField: 'name',
        keyData: 'data',
        render: function(data, type, row) {
          return row.estadoDetalle ? row.estadoDetalle.name : '<i>No establecido</i>';
        }
      }, {
        data: 'paquete.paquete.codigo',
        title: this.translations['Cod. Paquete'],
        render: function(data, type, row) {
          return row.paquete ? row.paquete.paquete.codigo : '<i>Sin Paquete</i>';
        }
      }
    ],
    defaultOrderColumn: 0,
    defaultOrderDir: 'desc',
    onEdit: () => { false; },
    onRemove: () => { false; },
    onView: () => { false; },
    canEditCondition: () => { false; },
    canListCondition: () => { false; },
    canRemoveCondition: () => { false; },
    canView: canView.bind(this),
    canEdit: canEdit.bind(this),
    canCancelar: canCancelar.bind(this),
    canAutorizar: canAutorizar.bind(this),
    canProcesar: canProcesar.bind(this),
    canReProcesar: canReProcesar.bind(this),
    canPaqueteCliente: canPaqueteCliente.bind(this),
    extraRowOptions: [
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-info btn-dt" uib-tooltip="' + this.translations['Ver orden de trabajo'] + '" ng-show="options.canView(rowsData[<%= dataId %>])" ng-click="view(rowsData[<%= dataId %>])"> <span class="glyphicon glyphicon-eye-open"></span></button>',
        functionName: 'view',
        functionDef: (data) => {
          $state.go('home.ordenes.uid.view', { uid: data.orden.id });
        }
      },
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-success btn-dt" uib-tooltip="' + this.translations['Editar orden de trabajo'] + '" ng-show="options.canEdit(rowsData[<%= dataId %>])" ng-click="edit(rowsData[<%= dataId %>])"> <span class="glyphicon glyphicon-pencil"></span></button>',
        functionName: 'edit',
        functionDef: (data) => {
          $state.go('home.ordenes.uid.edit', { uid: data.orden.id });
        }
      },
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-primary btn-dt" uib-tooltip="' + this.translations['Autorizar'] + '" ng-show="options.canAutorizar(rowsData[<%= dataId %>])" ng-click="autorizarOrden(<%= dataId %>)"> <span class="glyph-icon icon-check" style="top: -8px;"></span></button>',
        functionName: 'autorizarOrden',
        functionDef: (itemId) => {
          $ngRedux.dispatch(rest.actions.autorizarDetalle({ id: itemId }, {
            body: JSON.stringify({})
          }, (err, data) => {
            if (!err && data.codigo) {
              CustomModal.open({
                title: 'Autorización',
                id: itemId,
                ocultarCancelar: true,
                templateUrl: modalTemplate,
                message: 'El código de autorización es:',
                messageStrong: data.codigo,
                ok: function() {}
              });
            } else if (err) {
              ngNotify.set(err.message, 'warn');
            }
          }));
        }
      },
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-danger btn-dt" uib-tooltip="' + this.translations['Cancelar Servicio'] + '" ng-show="options.canCancelar(rowsData[<%= dataId %>])" ng-click="cancelarOrden(rowsData[<%= dataId %>])"> <span class="glyph-icon icon-close" style="top: -8px;"></span></button>',
        functionName: 'cancelarOrden',
        functionDef: (row) => {
          let self = this;
          let payload = {};
          CustomModal.open({
            title: 'Cancelar',
            id: row.id,
            payload,
            templateUrl: modalTemplate,
            autorizar: row.estadoDetalle.value === 'En proceso',
            message: '¿Seguro que desea cancelar el detalle de orden?',
            ok: function() {

              $ngRedux.dispatch(rest.actions.cancelarDetalle({ id: row.id }, {
                body: JSON.stringify(payload)
              }, (err, data) => {
                if (!err && data.estadoDetalle.value === 'Cancelado') {
                  ngNotify.set(self.translations['Cancelado Correctamente'], 'success');
                  self.options.reloadData();
                } else if (err) {
                  ngNotify.set(err.message, 'warn');
                }
              }));
            }
          });
        }
      },
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-warning btn-dt" uib-tooltip="' + this.translations['Procesar Comisión'] + '" ng-show="options.canProcesar(rowsData[<%= dataId %>])" ng-click="procesarComision(rowsData[<%= dataId %>])"> <span class="glyph-icon icon-gears" style="top: -8px;"></span></button>',
        functionName: 'procesarComision',
        functionDef: (row) => {
          let self = this;
          let payload = {};
          self.localModel.item = row;
          CustomModal.open({
            title: 'Procesar Comisión',
            item: row,
            vm: self,
            payload,
            templateUrl: procesarTemplate,
            message: 'Procesar comisión para esta detalle de orden',
            ok: function() {
              let requestPayload = {};
              if (payload.paquete && payload.tipo.value === 'Paquete') {
                requestPayload.paqueteClienteId = payload.paquete.id;
              } else if (payload.giftcard && payload.tipo.value === 'Giftcard') {
                requestPayload.giftcardId = payload.giftcard.id;
                requestPayload.codigoAutorizacion = payload.codigoAutorizacion;
              }

              $ngRedux.dispatch(rest.actions.procesarComisionServicio({ id: row.id }, {
                body: JSON.stringify(requestPayload)
              }, (err, data) => {
                if (!err && data.orden.tipo.value === 'Paquete') {
                  ngNotify.set(self.translations['Comision con paquete procesada'], 'success');
                  if (!data.periodoNomina) {
                    ngNotify.set(self.translations['Comision con paquete procesada (sin periodo nomina)'], 'warn');
                  }
                  self.options.reloadData();
                } else if (!err && (data.orden.tipo.value === 'Giftcard' || data.orden.tipo.value === 'Gentileza')) {
                  ngNotify.set(self.translations['Comision con giftcard procesada'], 'success');
                  if (!data.periodoNomina) {
                    ngNotify.set(self.translations['Comision con giftcard procesada (sin periodo nomina)'], 'warn');
                  }
                  self.options.reloadData();
                } else if (err) {
                  ngNotify.set(err.message, 'warn');
                }
              }));
            }
          });
        }
      },
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-primary btn-dt" uib-tooltip="' + this.translations['Paquetes del cliente'] + '" ng-show="options.canPaqueteCliente(rowsData[<%= dataId %>])" ng-click="paquetesCliente(rowsData[<%= dataId %>])"> <span class="glyph-icon icon-gift" style="top: -8px;"></span></button>',
        functionName: 'paquetesCliente',
        functionDef: (data) => {
          this.$state.go('home.clientes.uid.paquetes-cliente.eid.edit', { uid: data.orden.cliente.id, eid: data.paquete.id });
        }
      },
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-warning btn-dt" uib-tooltip="' + this.translations['ReProcesar Comisión'] + '" ng-show="options.canReProcesar(rowsData[<%= dataId %>])" ng-click="reprocesarComision(rowsData[<%= dataId %>])"> <span class="glyph-icon icon-mail-reply-all" style="top: -8px;"></span></button>',
        functionName: 'reprocesarComision',
        functionDef: (row) => {
          let self = this;
          let payload = {};
          CustomModal.open({
            title: 'Comisión Paquete',
            item: row,
            vm: self,
            payload,
            hideForm: true,
            templateUrl: procesarTemplate,
            message: 'Calcular o ReProcesar la Comisión para esta Orden utilizando',
            messageStrong: row.paquete.paquete.nombre,
            ok: function() {
              let requestPayload = {};

              $ngRedux.dispatch(rest.actions.reprocesarComisionPaquete({ id: row.id }, {
                body: JSON.stringify(requestPayload)
              }, (err, data) => {
                if (!err && data) {
                  ngNotify.set(self.translations['Comision con paquete procesada'], 'success');
                  self.options.reloadData();
                } else if (err) {
                  ngNotify.set(err.message, 'warn');
                }
              }));
            }
          });
        }
      }
    ]
  };

  function canPaqueteCliente(data) {
    return data.paquete && AuthorizationService.hasPermission('index_paquetes');
  }

  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);

  function canAutorizar(data) {
    return (data.estadoDetalle.value !== 'Cancelado') && AuthorizationService.hasPermission('auth_orden_trabajo');
  }

  function canCancelar(data) {
    return (data.orden.estado.value === 'En proceso' && (data.estadoDetalle.value === 'En proceso' || data.estadoDetalle.value === 'No iniciado')) && AuthorizationService.hasPermission('update_orden_trabajo');
  }

  function canProcesar(data) {
    return (data.orden.estado.value === 'Finalizada' && data.estadoDetalle.value === 'Finalizado' && (data.orden.tipo.value === 'Cita' || data.orden.tipo.value === 'Turno') && (data.tipo.value === 'Cita' || data.tipo.value === 'Turno') && AuthorizationService.hasPermission('update_orden_trabajo'));
  }

  function canReProcesar(data) {
    return (data.orden.estado.value === 'Facturada' && data.estadoDetalle.value === 'Finalizado' && data.paquete) && AuthorizationService.hasPermission('update_orden_trabajo');
  }

  function canView(data) {
    return AuthorizationService.hasPermission('update_orden_trabajo');
  }

  function canEdit(data) {
    return (data.orden.estado.value === 'En proceso' || data.orden.estado.value === 'Finalizada') && AuthorizationService.hasPermission('update_orden_trabajo');
  }

  const unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.$onInit = () => {
    this.reportOptions = {
      title: this.translations['Listado de ordenes']
    };
    this.form();
  };

  function mapStateToThis(state) {

    this.handleStatus(state);
    return { form: state.form };
  }

  function handleStatus(state) {
    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }
  }

  this.renderGiftcard = renderGiftcard.bind(this);


  function renderGiftcard(giftcard) {
    return `${giftcard.codigo} (${$filter('currency')(giftcard.montoRestante, 'Gs.', 0)}) ${giftcard.servicio ? ' - ' + giftcard.servicio.nombre : ''}`;
  }

  function renderPaqueteCliente(paqueteCliente) {
    return `<div class="paquete">${paqueteCliente.paquete.codigo} (${paqueteCliente.paquete.servicio.nombre}) <div class="select-detalles"><small>Sesiones Pagadas: ${paqueteCliente.cantidadSesionesPagadas } - Sesiones Ejecutadas: ${paqueteCliente.cantidadSesionesEjecutadas }  <small/></div></div>`;
  }

  this.renderPaqueteCliente = renderPaqueteCliente.bind(this);
  this.loadGiftcards = loadGiftcards.bind(this);
  this.loadPaquetesCliente = loadPaquetesCliente.bind(this);

  function loadGiftcards(query, item) {
    let today = new Date();
    let filterVigencia = Filter.path('vigenciaInicio').lte(today).and(Filter.path('vigenciaFin').gte(today));
    let filterTipo = Filter.path('tipo.value').eq('De Servicio');
    let filterEstado = Filter.path('estado.value').eq('Habilitada').or(Filter.path('estado.value').eq('Saldo Pendiente'));
    let filterServicio = Filter.path('servicio.id').eq(item.servicio.id);
    if (item.servicio.servicioPadre) {
      filterServicio = filterServicio.and(Filter.path('servicio.servicioPadre.id').eq(item.servicio.servicioPadre.id));
    }
    let filter = filterVigencia.and(filterTipo).and(filterEstado);
    
    if (query) {
      filter = filter.and(Filter.path('codigo').like(query)
        .or(Filter.path('servicio.nombre').like(query)));
    }

    BasicFactory.setup('giftcards');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }

  function loadPaquetesCliente(query, item) {
    let filter = Filter.path('estadoSesiones.value').eq('Pendiente')
      .and(Filter.path('cliente.id').eq(item.orden.cliente.id));

    if (query) {
      filter = filter.and(Filter.path('paquete.codigo').like(query));
      //.or(Filter.path('paquete.servicio.nombre').like(item.servicio.nombre)));
    }

    BasicFactory.setup('paquetes-cliente');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }

  this.filterGiftcards = filterGiftcards.bind(this);
  function filterGiftcards(giftcard) {
    let orden = this.localModel.item;
    if (giftcard.servicio) {
      if (orden.servicio.servicioPadre) {
        // Si el sevicio de la orden tiene servicio padre, 
        // mostrar si el servicio de la orden es el mismo o hijo del servicio de la giftcard
        return orden.servicio.id === giftcard.servicio.id || orden.servicio.servicioPadre.id === giftcard.servicio.id;
      } else {
        // Si el sevicio de la giftcard no tiene servicio padre, 
        // mostrar solo si es igual al servicio de la orden
        return orden.servicio.id === giftcard.servicio.id;
      }
    }
    // Si la giftcard no es de servicio, mostrar.
    return true;
  }
}


// WEBPACK FOOTER //
// ./src/components/ordenes/detalles-list/detalles.component.js